var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "station-discount-manage" },
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchInfo }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "选择油站:" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "请选择",
                        clearable: ""
                      },
                      model: {
                        value: _vm.searchInfo.stationId,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "stationId", $$v)
                        },
                        expression: "searchInfo.stationId"
                      }
                    },
                    _vm._l(_vm.stationOptions, function(item) {
                      return _c("el-option", {
                        key: item.ID,
                        attrs: { label: item.stationName, value: item.ID }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "油品" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.searchInfo.oilCode,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "oilCode", $$v)
                        },
                        expression: "searchInfo.oilCode"
                      }
                    },
                    _vm._l(_vm.oilCodesOptions, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "会员群:" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "请选择",
                        clearable: ""
                      },
                      model: {
                        value: _vm.searchInfo.userGroupId,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "userGroupId", $$v)
                        },
                        expression: "searchInfo.userGroupId"
                      }
                    },
                    _vm._l(_vm.userGroupOptions, function(item) {
                      return _c("el-option", {
                        key: item.ID,
                        attrs: {
                          label: item.groupName + item.parentName,
                          value: item.ID
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "ID:" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入ID" },
                    model: {
                      value: _vm.searchInfo.ID,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "ID", $$v)
                      },
                      expression: "searchInfo.ID"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onSearch } }, [
                    _vm._v("查询")
                  ])
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onView } },
                    [_vm._v("查看")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onAdd } },
                    [_vm._v("新增/预设")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onUpdate } },
                    [_vm._v("变更")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: { click: _vm.onBatchDelete }
                    },
                    [_vm._v("批量删除")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "tooltip-effect": "dark"
          },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", width: "55", prop: "ID" }
          }),
          _c("el-table-column", {
            attrs: { width: "55", label: "ID", prop: "ID" }
          }),
          _c("el-table-column", {
            attrs: { label: "活动名称", prop: "discountTitle", width: "120" }
          }),
          _c("el-table-column", {
            attrs: { label: "油站编号", prop: "stationId", width: "80" }
          }),
          _c("el-table-column", {
            attrs: { label: "油站名称", prop: "stationId" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      _vm._s(_vm._f("getStationName")(scope.row.stationId))
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "油品", prop: "oilCode" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("getOilCodeNames")(scope.row.oilCode)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "会员群", prop: "userGroupId" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      _vm._s(_vm._f("getUserGroupNames")(scope.row.userGroupId))
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "单升优惠", prop: "discount", width: "120" }
          }),
          _c("el-table-column", {
            attrs: { label: "升数限制", prop: "leastOilMass", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm._f("getLeastOilMassNames")(scope.row.leastOilMass)
                      )
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "券限制", prop: "isAddTicket", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.isAddTicket == 1
                      ? _c("span", [_vm._v("可用油品券")])
                      : _vm._e(),
                    scope.row.isAddTicket == 2
                      ? _c("span", [_vm._v("不可用油品券")])
                      : _vm._e(),
                    scope.row.isAddTicket == 3
                      ? _c("span", [_vm._v("部分券可用")])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "有效时间" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", [
                      _vm._v(_vm._s(_vm._f("formatDate")(scope.row.dateStart)))
                    ]),
                    _c("div", [
                      _vm._v(_vm._s(_vm._f("formatDate")(scope.row.dateEnd)))
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "每周时间" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("getWeekNames")(scope.row.cycleDays)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "每天时间", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.timeStart))]),
                    _c("div", [_vm._v(_vm._s(scope.row.timeEnd))])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.onClose,
            visible: _vm.addVisible,
            title: "新增操作"
          },
          on: {
            "update:visible": function($event) {
              _vm.addVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                model: _vm.formData,
                rules: _vm.getRule,
                "label-position": "right"
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "活动名称:", prop: "discountTitle" }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: "如：xxx会员日"
                            },
                            model: {
                              value: _vm.formData.discountTitle,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "discountTitle", $$v)
                              },
                              expression: "formData.discountTitle"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "油站:", prop: "stationIdString" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                placeholder: "请选择"
                              },
                              model: {
                                value: _vm.stationIdChecked,
                                callback: function($$v) {
                                  _vm.stationIdChecked = $$v
                                },
                                expression: "stationIdChecked"
                              }
                            },
                            _vm._l(_vm.stationOptions, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.stationName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "油品:", prop: "oilCodeString" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: { change: _vm.handleCheckAllChange },
                              model: {
                                value: _vm.oilCodesCheckAll,
                                callback: function($$v) {
                                  _vm.oilCodesCheckAll = $$v
                                },
                                expression: "oilCodesCheckAll"
                              }
                            },
                            [_vm._v("全选")]
                          ),
                          _c(
                            "el-checkbox-group",
                            {
                              on: { change: _vm.handleCheckedOilCodesChange },
                              model: {
                                value: _vm.oilCodesChecked,
                                callback: function($$v) {
                                  _vm.oilCodesChecked = $$v
                                },
                                expression: "oilCodesChecked"
                              }
                            },
                            _vm._l(_vm.oilCodesOptions, function(oil) {
                              return _c(
                                "el-checkbox",
                                { key: oil.value, attrs: { label: oil.value } },
                                [_vm._v(_vm._s(oil.label))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "会员群:", prop: "userGroupId" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                filterable: "",
                                placeholder: "请选择",
                                clearable: ""
                              },
                              model: {
                                value: _vm.formData.userGroupId,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "userGroupId", $$v)
                                },
                                expression: "formData.userGroupId"
                              }
                            },
                            _vm._l(_vm.userGroupOptions, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.groupName + item.parentName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "日期范围:",
                            prop: "dateRangeValueArr"
                          }
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetimerange",
                              align: "right",
                              "unlink-panels": "",
                              "picker-options": _vm.pickerOptions,
                              "range-separator": "至",
                              "start-placeholder": "开始",
                              "end-placeholder": "结束",
                              format: "yyyy-MM-dd HH:mm:ss",
                              "value-format": "yyyy-MM-dd HH:mm:ss"
                            },
                            model: {
                              value: _vm.dateRangeValueArr,
                              callback: function($$v) {
                                _vm.dateRangeValueArr = $$v
                              },
                              expression: "dateRangeValueArr"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "每周时间:", prop: "weekChecked" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: { change: _vm.handleCheckWeekAllChange },
                              model: {
                                value: _vm.weekCheckAll,
                                callback: function($$v) {
                                  _vm.weekCheckAll = $$v
                                },
                                expression: "weekCheckAll"
                              }
                            },
                            [_vm._v("全选")]
                          ),
                          _c(
                            "el-checkbox-group",
                            {
                              on: { change: _vm.handleCheckedWeekChange },
                              model: {
                                value: _vm.weekChecked,
                                callback: function($$v) {
                                  _vm.weekChecked = $$v
                                },
                                expression: "weekChecked"
                              }
                            },
                            _vm._l(_vm.weekOptions, function(week) {
                              return _c(
                                "el-checkbox",
                                {
                                  key: week.value,
                                  attrs: { label: week.value }
                                },
                                [_vm._v(_vm._s(week.label))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "每天时间:",
                            prop: "timeRangeValueArr"
                          }
                        },
                        [
                          _c("el-time-picker", {
                            attrs: {
                              "is-range": "",
                              "range-separator": "至",
                              "start-placeholder": "开始时间",
                              "end-placeholder": "结束时间",
                              placeholder: "选择时间范围",
                              format: "HH:mm:ss",
                              "value-format": "HH:mm:ss"
                            },
                            model: {
                              value: _vm.timeRangeValueArr,
                              callback: function($$v) {
                                _vm.timeRangeValueArr = $$v
                              },
                              expression: "timeRangeValueArr"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "单升优惠(元):", prop: "discount" } },
                        [
                          _c("el-input-number", {
                            attrs: {
                              step: "0.1",
                              min: 0,
                              clearable: "",
                              placeholder: "请输入"
                            },
                            model: {
                              value: _vm.formData.discount,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "discount", $$v)
                              },
                              expression: "formData.discount"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "升数限制(升):",
                            prop: "leastOilMass"
                          }
                        },
                        [
                          _c("el-input-number", {
                            attrs: {
                              clearable: "",
                              placeholder: "请输入，0则不限制"
                            },
                            model: {
                              value: _vm.formData.leastOilMass,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "leastOilMass", $$v)
                              },
                              expression: "formData.leastOilMass"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "券限制:", prop: "isAddTicket" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.isAddTicket,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "isAddTicket", $$v)
                                },
                                expression: "formData.isAddTicket"
                              }
                            },
                            [
                              _c("el-radio", { key: 1, attrs: { label: 1 } }, [
                                _vm._v("可用油品券")
                              ]),
                              _c("el-radio", { key: 2, attrs: { label: 2 } }, [
                                _vm._v("不可用油品券")
                              ]),
                              _c("el-radio", { key: 3, attrs: { label: 3 } }, [
                                _vm._v("部分券可用")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              [3].includes(_vm.formData.isAddTicket)
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "bairun-required",
                              attrs: { label: "已选优惠券：" }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-add"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onAddTicket()
                                    }
                                  }
                                },
                                [_vm._v("添加优惠券")]
                              ),
                              _c("br"),
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.formData.discountPriceTicketList,
                                    border: "",
                                    stripe: "",
                                    "max-height": "280px",
                                    "tooltip-effect": "dark"
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "券编号",
                                      prop: "ticketRuleNo"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "券名称",
                                      prop: "ticketName"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "操作", width: "120px" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { size: "mini" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.onDelActivityTicket(
                                                        scope.row
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(" 移除 ")]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      142889960
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.onClose } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.onClose,
            visible: _vm.updateVisible,
            title: "变更操作"
          },
          on: {
            "update:visible": function($event) {
              _vm.updateVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "updateFormData",
              attrs: {
                model: _vm.formData,
                rules: _vm.getRule,
                "label-position": "right"
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "活动名称:", prop: "discountTitle" }
                        },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.formData.discountTitle,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "discountTitle", $$v)
                              },
                              expression: "formData.discountTitle"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "油站:", prop: "stationId" } },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm._f("getStationName")(
                                _vm.formData.stationId
                              ),
                              disabled: ""
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "油品:", prop: "oilCode" } },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm._f("getOilCodeNames")(
                                _vm.formData.oilCode
                              ),
                              disabled: ""
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "会员群:", prop: "userGroupId" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.formData.userGroupId,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "userGroupId", $$v)
                                },
                                expression: "formData.userGroupId"
                              }
                            },
                            _vm._l(_vm.userGroupOptions, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.groupName + item.parentName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "日期范围:",
                            prop: "dateRangeValueArr"
                          }
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetimerange",
                              align: "right",
                              "unlink-panels": "",
                              "picker-options": _vm.pickerOptions,
                              "range-separator": "至",
                              "start-placeholder": "开始",
                              "end-placeholder": "结束",
                              format: "yyyy-MM-dd HH:mm:ss",
                              "value-format": "yyyy-MM-dd HH:mm:ss"
                            },
                            model: {
                              value: _vm.dateRangeValueArr,
                              callback: function($$v) {
                                _vm.dateRangeValueArr = $$v
                              },
                              expression: "dateRangeValueArr"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "每周时间:", prop: "weekChecked" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: { change: _vm.handleCheckWeekAllChange },
                              model: {
                                value: _vm.weekCheckAll,
                                callback: function($$v) {
                                  _vm.weekCheckAll = $$v
                                },
                                expression: "weekCheckAll"
                              }
                            },
                            [_vm._v("全选")]
                          ),
                          _c(
                            "el-checkbox-group",
                            {
                              on: { change: _vm.handleCheckedWeekChange },
                              model: {
                                value: _vm.weekChecked,
                                callback: function($$v) {
                                  _vm.weekChecked = $$v
                                },
                                expression: "weekChecked"
                              }
                            },
                            _vm._l(_vm.weekOptions, function(week) {
                              return _c(
                                "el-checkbox",
                                {
                                  key: week.value,
                                  attrs: { label: week.value }
                                },
                                [_vm._v(_vm._s(week.label))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "每天时间:",
                            prop: "timeRangeValueArr"
                          }
                        },
                        [
                          _c("el-time-picker", {
                            attrs: {
                              "is-range": "",
                              "range-separator": "至",
                              "start-placeholder": "开始时间",
                              "end-placeholder": "结束时间",
                              placeholder: "选择时间范围",
                              format: "HH:mm:ss",
                              "value-format": "HH:mm:ss"
                            },
                            model: {
                              value: _vm.timeRangeValueArr,
                              callback: function($$v) {
                                _vm.timeRangeValueArr = $$v
                              },
                              expression: "timeRangeValueArr"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "单升优惠(元):", prop: "discount" } },
                        [
                          _c("el-input-number", {
                            attrs: {
                              step: "0.1",
                              min: 0,
                              clearable: "",
                              placeholder: "请输入"
                            },
                            model: {
                              value: _vm.formData.discount,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "discount", $$v)
                              },
                              expression: "formData.discount"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "升数限制(升):",
                            prop: "leastOilMass"
                          }
                        },
                        [
                          _c("el-input-number", {
                            attrs: {
                              clearable: "",
                              placeholder: "请输入，0则不限制"
                            },
                            model: {
                              value: _vm.formData.leastOilMass,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "leastOilMass", $$v)
                              },
                              expression: "formData.leastOilMass"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "券限制:", prop: "isAddTicket" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.isAddTicket,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "isAddTicket", $$v)
                                },
                                expression: "formData.isAddTicket"
                              }
                            },
                            [
                              _c("el-radio", { key: 1, attrs: { label: 1 } }, [
                                _vm._v("可用油品券")
                              ]),
                              _c("el-radio", { key: 2, attrs: { label: 2 } }, [
                                _vm._v("不可用油品券")
                              ]),
                              _c("el-radio", { key: 3, attrs: { label: 3 } }, [
                                _vm._v("部分券可用")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              [3].includes(_vm.formData.isAddTicket)
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "bairun-required",
                              attrs: { label: "已选优惠券：" }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-add"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onAddTicket()
                                    }
                                  }
                                },
                                [_vm._v("添加优惠券")]
                              ),
                              _c("br"),
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.formData.discountPriceTicketList,
                                    border: "",
                                    stripe: "",
                                    "max-height": "280px",
                                    "tooltip-effect": "dark"
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "券编号",
                                      prop: "ticketRuleNo"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "券名称",
                                      prop: "ticketName"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "操作", width: "120px" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { size: "mini" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.onDelActivityTicket(
                                                        scope.row
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(" 移除 ")]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      142889960
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.onClose } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.onClose,
            visible: _vm.viewVisible,
            title: "变更操作"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "viewFormData",
              attrs: { model: _vm.formData, "label-position": "right" }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动名称:" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.discountTitle,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "discountTitle", $$v)
                              },
                              expression: "formData.discountTitle"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "油站:", prop: "stationId" } },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm._f("getStationName")(
                                _vm.formData.stationId
                              )
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "油品:", prop: "oilCode" } },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm._f("getOilCodeNames")(
                                _vm.formData.oilCode
                              )
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "会员群:", prop: "userGroupId" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                filterable: "",
                                placeholder: "请选择",
                                clearable: ""
                              },
                              model: {
                                value: _vm.formData.userGroupId,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "userGroupId", $$v)
                                },
                                expression: "formData.userGroupId"
                              }
                            },
                            _vm._l(_vm.userGroupOptions, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.groupName + item.parentName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "日期范围:" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetimerange",
                              align: "right",
                              "unlink-panels": "",
                              "picker-options": _vm.pickerOptions,
                              "range-separator": "至",
                              "start-placeholder": "开始",
                              "end-placeholder": "结束",
                              format: "yyyy-MM-dd HH:mm:ss",
                              "value-format": "yyyy-MM-dd HH:mm:ss"
                            },
                            model: {
                              value: _vm.dateRangeValueArr,
                              callback: function($$v) {
                                _vm.dateRangeValueArr = $$v
                              },
                              expression: "dateRangeValueArr"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "每周时间:", prop: "cycleDays" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.weekCheckAll,
                                callback: function($$v) {
                                  _vm.weekCheckAll = $$v
                                },
                                expression: "weekCheckAll"
                              }
                            },
                            [_vm._v("全选")]
                          ),
                          _c(
                            "el-checkbox-group",
                            {
                              on: { change: _vm.handleCheckedWeekChange },
                              model: {
                                value: _vm.weekChecked,
                                callback: function($$v) {
                                  _vm.weekChecked = $$v
                                },
                                expression: "weekChecked"
                              }
                            },
                            _vm._l(_vm.weekOptions, function(week) {
                              return _c(
                                "el-checkbox",
                                {
                                  key: week.value,
                                  attrs: { label: week.value }
                                },
                                [_vm._v(_vm._s(week.label))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "每天时间:", prop: "" } },
                        [
                          _c("el-time-picker", {
                            attrs: {
                              "is-range": "",
                              "range-separator": "至",
                              "start-placeholder": "开始时间",
                              "end-placeholder": "结束时间",
                              placeholder: "选择时间范围",
                              format: "HH:mm:ss",
                              "value-format": "HH:mm:ss"
                            },
                            model: {
                              value: _vm.timeRangeValueArr,
                              callback: function($$v) {
                                _vm.timeRangeValueArr = $$v
                              },
                              expression: "timeRangeValueArr"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "单升优惠(元):", prop: "discount" } },
                        [
                          _c("el-input-number", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.formData.discount,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "discount", $$v)
                              },
                              expression: "formData.discount"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "升数限制(升):",
                            prop: "leastOilMass"
                          }
                        },
                        [
                          _c("el-input-number", {
                            attrs: {
                              clearable: "",
                              placeholder: "请输入，0则不限制"
                            },
                            model: {
                              value: _vm.formData.leastOilMass,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "leastOilMass", $$v)
                              },
                              expression: "formData.leastOilMass"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "券限制:", prop: "isAddTicket" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.isAddTicket,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "isAddTicket", $$v)
                                },
                                expression: "formData.isAddTicket"
                              }
                            },
                            [
                              _c("el-radio", { key: 1, attrs: { label: 1 } }, [
                                _vm._v("可用油品券")
                              ]),
                              _c("el-radio", { key: 2, attrs: { label: 2 } }, [
                                _vm._v("不可用油品券")
                              ]),
                              _c("el-radio", { key: 3, attrs: { label: 3 } }, [
                                _vm._v("部分券可用")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              [3].includes(_vm.formData.isAddTicket)
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "已选优惠券：" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-add"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onAddTicket()
                                    }
                                  }
                                },
                                [_vm._v("添加优惠券")]
                              ),
                              _c("br"),
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.formData.discountPriceTicketList,
                                    border: "",
                                    stripe: "",
                                    "max-height": "280px",
                                    "tooltip-effect": "dark"
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "券编号",
                                      prop: "ticketRuleNo"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "券名称",
                                      prop: "ticketName"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "操作", width: "120px" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { size: "mini" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.onDelActivityTicket(
                                                        scope.row
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(" 移除 ")]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      142889960
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [_c("el-button", { on: { click: _vm.onClose } }, [_vm._v("关闭")])],
            1
          )
        ],
        1
      ),
      _vm.couponFormData.dialogVisible
        ? _c("couponSelect", {
            attrs: { "goods-component-form-data": _vm.couponFormData }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }